import React, { Component } from 'react';
import { Button } from 'antd';
import LibraryCreateDialog from '../LibraryCreateDialog';
import RenderMediaItem from './RenderMediaItem';
import { PlusOutlined } from '@ant-design/icons';
import './MediaWrapper.scss';

export default class LibraryListDisplay extends Component {
	render() {
		const {
			libraries,
			event,
			client,
			refetch,
			handleLibraryUploadOpen,
			libraryCreateDialogOpen,
			handleLibraryUploadClose,
			handleLibraryCreate,
			handlePickItem,
			showHeader,
		} = this.props;
		const header = (
			<>
				<h3>Libraries</h3>
				<Button type="primary" onClick={handleLibraryUploadOpen}>
					<PlusOutlined /> New Library
				</Button>
			</>
		);
		return (
			<div className="libraryListWrapper" style={{ width: handlePickItem ? '100%' : '30%' }}>
				<RenderMediaItem
					header={showHeader ? header : null}
					media={libraries}
					libraryType={true}
					linkType={'eventLibrary'}
					event={event}
					handlePickItem={handlePickItem}
				/>
				<LibraryCreateDialog
					visible={libraryCreateDialogOpen}
					onCancel={handleLibraryUploadClose}
					onCreate={handleLibraryCreate}
					client={client}
					event={event}
					refetch={refetch}
				/>
			</div>
		);
	}
}
